import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-youtube',
  imports: [],
  templateUrl: './icon-youtube.component.html',
  styleUrl: './icon-youtube.component.scss'
})
export class IconYoutubeComponent {

}
